// The types of values supported in a rule expression. These are used in definitions to inform how
// values can be used in expressions.
export enum RuleExpressionValueTypeEnum {
  ARRAYNUMBER = 'arraynumber',
  ARRAYSTRING = 'arraystring',
  BOOLEAN = 'boolean',
  NUMBER = 'number',
  STRING = 'string',
}
